<flo-simple-header
  [siteId]="siteSettings.site_id"
  [isLoginDisplayed]="true"
  [isSignupDisplayed]="isNavSignupDisplayed"
  (loginButtonClicked)="handleLoginButtonClicked()"
  (signUpButtonClicked)="handleSignUpButtonClicked()"
  floElementIsVisible
  (elementIsVisible)="hideSignupButton()">
</flo-simple-header>

<flo-landing-hero 
  (signUpButtonClicked)="handleSignUpButtonClicked()" 
  [heroContent]="heroContent"
  [liveEventHeader]="liveEventHeader"
  [bgPosition]="heroBackgroundPosition"
  >
</flo-landing-hero>

<flo-logos-display [imageUrls]="logoContent?.imageUrls"></flo-logos-display>

<flo-event-card-scroll 
  [eventCardContainer]="upNextContent$ | async" 
  [geoBlockedIds]="geoBlockedIds$ | async" 
  data-test="event-card-scroll">
</flo-event-card-scroll>

<flo-plans-promo-section
  [isPlansVariation]="isPlansVariation"
  [offers]="offers"
  [sportName]="siteSettings.sport_name"
  (offerSelected)="handleOfferSelected($event)"
  floElementIsVisible
  (elementIsVisible)="showNavSignupButton()"
  (signupSelected)="handleSignUpButtonClicked()">
</flo-plans-promo-section>

<flo-streaming-hero
  floElementIsVisible
  (elementIsVisible)="showNavSignupButton()">
</flo-streaming-hero>

<flo-faq-section [header]="'Frequently Asked Questions'" [siteSettings]="siteSettings"></flo-faq-section>
